const WORKING_MESSAGE_COUNT = 32

export const WORKING_MESSAGE_KEYS: string[] = Array.from({ length: WORKING_MESSAGE_COUNT }, (_, index) => `bot.agent.workingMessage.${index}`)

export function getRandomWorkingMessageKey(): string {
  const index = Math.floor(Math.random() * WORKING_MESSAGE_KEYS.length)
  return WORKING_MESSAGE_KEYS[index]
}
